import { useQuery } from "@tanstack/react-query";
import { serviceApi } from "@/api/services/services";
import { categoryApi } from "@/api/services/categories";

export function useServicesForStaff() {
  return useQuery({
    queryKey: ["services", { active_only: true, size: 100 }],
    queryFn: async () => {
      const response = await serviceApi.getServices({ active_only: true, size: 100 });
      return response.items;
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}

export function useServiceCategoriesForStaff() {
  return useQuery({
    queryKey: ["service-categories", { active_only: true, size: 100 }],
    queryFn: async () => {
      const response = await categoryApi.getCategories({ active_only: true, size: 100 });
      return response.items;
    },
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
}
